import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import { Text, Type, Stack, Card } from '@nerdwallet/currency';
import { withRouter } from 'react-router';
import {
  getDepartmentEnabled,
  getDepartmentRelativePath,
  getSlug,
} from '~/client/lib/department-utils';
import grnhseTrackingCheck from '../../../lib/company-content-src/grnhse-tracking-check';

import DepartmentMappings from '../../../lib/company-content-src/department-mappings';
import styles from './companyDepartments.module.less';

const CompanyDepartmentsTile = ({ department, location }) => {
  const { name, jobs } = department;
  const slug = getSlug(department);
  const relativePath = getDepartmentRelativePath(department);

  if (!getDepartmentEnabled(slug)) return null;

  return (
    <Card
      primary
      href={grnhseTrackingCheck(relativePath, location.search)}
      className={styles.departmentsTile}
    >
      <Stack spacing="1" className={styles.departmentsContent}>
        {name && (
          <div
            className={classNames([
              classes('margin-bottom-3'),
              classes('display-block'),
              classes('text-align-left'),
            ])}
          >
            <Text size="large" bold>
              {name}
            </Text>
          </div>
        )}
        {DepartmentMappings[slug].body && (
          <Type
            size="1"
            default
            className={classNames([
              classes('margin-bottom-3'),
              classes('display-block'),
              classes('text-align-left'),
            ])}
          >
            {DepartmentMappings[slug].body}
          </Type>
        )}
        <Type
          gotham
          size="1"
          color="blue-light"
          uppercase
          bold
          className={classNames(['departments__jobs'])}
        >
          {jobs.length === 1 && <span>{jobs.length} open position</span>}
          {jobs.length > 1 && <span>{jobs.length} open positions</span>}
          {jobs.length === 0 && <span>no open positions</span>}
        </Type>
      </Stack>
    </Card>
  );
};

CompanyDepartmentsTile.propTypes = {
  department: PropTypes.object,
  location: PropTypes.object,
};

CompanyDepartmentsTile.displayName = 'Company Departments Tile';

const CompanyDepartmentsTileWithRouter = withRouter(CompanyDepartmentsTile);

export default CompanyDepartmentsTileWithRouter;
